/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscordMessageBody } from './DiscordMessageBody';
import {
    DiscordMessageBodyFromJSON,
    DiscordMessageBodyFromJSONTyped,
    DiscordMessageBodyToJSON,
    DiscordMessageBodyToJSONTyped,
} from './DiscordMessageBody';

/**
 * 
 * @export
 * @interface DiscordRelayMessageBody
 */
export interface DiscordRelayMessageBody {
    /**
     * 
     * @type {DiscordMessageBody}
     * @memberof DiscordRelayMessageBody
     */
    message: DiscordMessageBody;
    /**
     * Bot authentication token
     * @type {string}
     * @memberof DiscordRelayMessageBody
     */
    botToken: string;
}

/**
 * Check if a given object implements the DiscordRelayMessageBody interface.
 */
export function instanceOfDiscordRelayMessageBody(value: object): value is DiscordRelayMessageBody {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('botToken' in value) || value['botToken'] === undefined) return false;
    return true;
}

export function DiscordRelayMessageBodyFromJSON(json: any): DiscordRelayMessageBody {
    return DiscordRelayMessageBodyFromJSONTyped(json, false);
}

export function DiscordRelayMessageBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayMessageBody {
    if (json == null) {
        return json;
    }
    return {
        
        'message': DiscordMessageBodyFromJSON(json['message']),
        'botToken': json['botToken'],
    };
}

export function DiscordRelayMessageBodyToJSON(json: any): DiscordRelayMessageBody {
    return DiscordRelayMessageBodyToJSONTyped(json, false);
}

export function DiscordRelayMessageBodyToJSONTyped(value?: DiscordRelayMessageBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': DiscordMessageBodyToJSON(value['message']),
        'botToken': value['botToken'],
    };
}

